module.exports = {
    flexiapp_main_url: 'https://flexiapp-admin.tibagroup.com',
    flexiapp_service_url: 'https://flexiapp-api.tibagroup.com/',
    flexiapp_auth_url: 'https://auth.grm-e.com/token',
    imposter_service_url : 'https://SERVER5UA9N0DV-imposter-service-server-28080.che.vbote.com/' ,
    flexiapp_gtag_id: 'G-ZJBL9TJWVY',
    appId: 20046,
version : '1.0.116' ,
};